import { IShop } from '@dash.bar/types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useLiveTracker from '../../../../pages/LiveTracker/v1/useLiveTracker'
import AvatarHorizontalScroll from '../AvatarHorizontalScroll'

type PropsT = {
  shop: IShop
  type: string
}

const CustomerHorizontalScroll = ({ shop, type }: PropsT) => {
  const {
    state: { loading, data },
    nextPage,
  } = useLiveTracker({ shop, type })
  const { t } = useTranslation()

  const customers = data?.data
  return (
    <>
      <AvatarHorizontalScroll
        shop={shop}
        title={t('shop.live-tracker.customer')}
        userList={customers}
        loading={loading}
        onEndReached={() => {
          if (!loading) {
            nextPage()
          }
        }}
      />
    </>
  )
}

export default CustomerHorizontalScroll
